export default __webpack_public_path__ + "static/media/reporting.71e13905.gif";